import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitWith'
})
export class SplitWithPipe implements PipeTransform {

  transform(value: string, separator: string): any {
    if (value) {
      return value.split(separator).map((item) => item.trim());
    }
    return null;
  }
}
